<script>

import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  components: {
  },
  props: ['users'],
  name: 'UserActivityByProfile',
  data () {
    return {
      options: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            distribution: 'series',
            ticks: {
              source: 'data',
              autoSkip: true
            },
            time: {
              unit: 'day',
              stepSize: 30
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Users'
            },
            ticks: {
              beginAtZero: true,
              steps: 1,
              stepSize: 1,
              min: 0
            }
          }]
        },
        tooltips: {
          intersect: false,
          mode: 'index'
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      data: {
        datasets: [{
        }],
        labels: []
      }
    }
  },
  methods: {
    draw: function () {
      this.data.datasets[0].data = []
      let newUsersValue = []
      let loginUsersValue = []
      let searchUsersValue = []

      let startDate = this.$moment().subtract(1, 'months')

      while (newUsersValue.length < 31) {
        startDate = startDate.clone().add(1, 'd')

        newUsersValue.push({x: startDate.format('MMM D'), y: 0})
        loginUsersValue.push({x: startDate.format('MMM D'), y: 0})
        searchUsersValue.push({x: startDate.format('MMM D'), y: 0})
      }

      newUsersValue.forEach((value) => {
        this.users.new.forEach((user) => {
          let date = this.$moment(user.created_at).format('MMM D')
          if (date === value.x) {
            ++value.y
          }
        })
      })

      loginUsersValue.forEach((value) => {
        this.users.login.forEach((user) => {
          let date = this.$moment(user.login_at).format('MMM D')
          if (date === value.x) {
            ++value.y
          }
        })
      })

      searchUsersValue.forEach((value) => {
        this.users.search.forEach((user) => {
          let date = this.$moment(user.created_at).format('MMM D')
          if (date === value.x) {
            ++value.y
          }
        })
      })

      this.data.datasets = [
        {
          label: 'New Users',
          data: newUsersValue,
          fill: false,
          backgroundColor: 'rgba(209, 29, 29, 0.5)',
          borderColor: 'rgba(209, 29, 29, 0.5)'
        }, {
          label: 'Login Users',
          data: loginUsersValue,
          fill: false,
          backgroundColor: 'rgba(0, 0, 244, 0.5)',
          borderColor: 'rgba(0, 0, 244, 0.5)'
        }, {
          label: 'Search Users',
          data: searchUsersValue,
          fill: false,
          backgroundColor: 'rgba(2, 140, 2, 0.8)',
          borderColor: 'rgba(2, 140, 2, 0.8)'
        }
      ]
      this.renderChart(this.data, this.options)
    }
  },
  mounted () {
    this.draw()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/UserActivityByProfile.vue